import { jsx as _jsx } from "react/jsx-runtime";
import React, { useEffect, useState } from 'react';
import './tenantListView.scss';
import TenantsListReactView from './TenantsListReactView';
const TenantsListReact = ({ tenants, expanded, TenantService, SegmentService, }) => {
    const [allTenants, setAllTenants] = useState(tenants);
    const [slicedTenants, setSlicedTenants] = useState(tenants.slice(0, 3));
    useEffect(() => {
        tenants.forEach(async (tenant, index) => {
            await getTenantShow(tenant);
            allTenants[index] = tenant;
            setAllTenants(allTenants);
            setSlicedTenants(allTenants.slice(0, 3));
        });
    }, []);
    const tenantsToList = expanded ? allTenants : slicedTenants;
    const onTenantClick = async (tenant) => {
        const tenantUrl = TenantService.getTenantUrl(tenant.id);
        await SegmentService.createTrack('organization-choice', {
            organizationName: tenant.name,
            organizationUrl: tenantUrl,
            status: 'success',
        });
    };
    const getTenantShow = async (tenant) => {
        tenant.accountType = await TenantService.getTenantPlan(tenant.id);
        tenant.url = await TenantService.getTenantUrl(tenant.id, false);
    };
    const getTenantUrl = (tenantId, withProtocol = true) => {
        if (tenantId) {
            return TenantService.getTenantUrl(tenantId, withProtocol);
        }
        return TenantService.getDefaultPortalUrl(withProtocol);
    };
    return (_jsx(TenantsListReactView, { tenantsToList: tenantsToList, slicedTenants: slicedTenants, onTenantClick: onTenantClick, getTenantUrl: getTenantUrl }));
};
export default TenantsListReact;
